var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLuggageSuitcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.332,
    height: 28.458,
    viewBox: "0 0 50.332 28.458",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_93",
    "data-name": "Gruppe 93",
    transform: "translate(-236.925 -60.087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_640",
    "data-name": "Pfad 640",
    d: "M243.886,76.084c-3.513-.253-5.249,1.634-5.742,2.867a21.013,21.013,0,0,0,.176,14.614c.542,1.516.7,2.946,7.905,2.661l.2-.008c-.406-3.1-1.5-12.876.082-17.344a7.346,7.346,0,0,0,.355-2.566C245.049,76.2,243.886,76.084,243.886,76.084Z",
    transform: "translate(0 -7.717)",
    fill: "#183f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_641",
    "data-name": "Pfad 641",
    d: "M285.127,76.714c-.947,0-1.929-.014-2.916-.053-1.879-.072-4.316-.127-6.8-.1-2.479-.032-4.917.023-6.795.1-.988.039-1.969.054-2.917.053a12.716,12.716,0,0,1-.676,4.24c-.781,2.2-.675,8.619.25,15.269l.031.217c3.089-.007,6.877-.02,10.107-.045,3.231.025,7.018.038,10.108.045l.03-.217c.925-6.65,1.031-13.071.251-15.269A12.72,12.72,0,0,1,285.127,76.714Z",
    transform: "translate(-13.324 -7.956)",
    fill: "#183f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_642",
    "data-name": "Pfad 642",
    d: "M323.786,78.951c-.493-1.233-2.228-3.119-5.742-2.867,0,0-1.162.118-2.979.223a7.344,7.344,0,0,0,.354,2.566c1.585,4.468.487,14.241.081,17.344l.2.008c7.2.285,7.363-1.145,7.905-2.661A21.006,21.006,0,0,0,323.786,78.951Z",
    transform: "translate(-37.748 -7.717)",
    fill: "#183f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_643",
    "data-name": "Pfad 643",
    d: "M285.535,67.146c.354-1.461.4-4.271-1.653-5.76l-.1-.072-.111-.055c-.242-.118-2.539-1.151-8.473-1.153-1.172-.018-10.99-.144-14.18.647a4.362,4.362,0,0,0-2.225,1.085,5.652,5.652,0,0,0-1.259,5.325,9.761,9.761,0,0,1-.308,4.445c-1.3,3.654-.672,11.771,0,16.845h2.833c-.829-5.964-1.16-13.159-.185-15.9a12.575,12.575,0,0,0,.409-5.971l-.009-.061-.025-.075a2.9,2.9,0,0,1,.53-2.616,1.7,1.7,0,0,1,.732-.306l.059-.008.085-.022c2.338-.606,10.544-.619,13.509-.574h.022a22.247,22.247,0,0,1,7.151.831c.9.818.463,2.747.46,2.76l-.016.07a12.573,12.573,0,0,0,.41,5.97c.975,2.746.644,9.941-.186,15.9h2.834c.672-5.073,1.3-13.191,0-16.845A9.775,9.775,0,0,1,285.535,67.146Z",
    transform: "translate(-9.442)",
    fill: "#183f75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuggageSuitcase);
export default __webpack_public_path__ + "static/media/luggage_suitcase.fcabdd3c979146002c37312858e2ed81.svg";
export { ForwardRef as ReactComponent };